import React, {createContext,  useContext,  useReducer} from "react";
import {getInitialStateGoals} from "../reducers/goalsReducer/initialValues";
import {reducerFn} from "../reducers/goalsReducer";

export const GoalContext = createContext({});

export const GoalProvider = (props) => {

    const [stateGoals, dispatchGoals] = useReducer(reducerFn, getInitialStateGoals());

    function changeTotalGoals(key, value, lang) {
        dispatchGoals({
            type: lang === 'pt-BR' ? 'add_goals_pt' : 'add_goals_en',
            content: {key, value}
        });
    }


    return (
        <GoalContext.Provider
            value={{
                goals: stateGoals,
                changeTotalGoals
            }}>
            {props.children}
        </GoalContext.Provider>
    )
}

export const useGoal = () => useContext(GoalContext);
